import { render, staticRenderFns } from "./McAlert.vue?vue&type=template&id=4d48288c&scoped=true&"
import script from "./McAlert.vue?vue&type=script&lang=js&"
export * from "./McAlert.vue?vue&type=script&lang=js&"
import style0 from "./McAlert.vue?vue&type=style&index=0&id=4d48288c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48288c",
  null
  
)

export default component.exports